import * as firebase from "firebase"
import * as analytics from "./analytics"

const TIMEOUT = 62500

export default async function request(uid, action, cb = null) {
	if (process.env.NODE_ENV === "development") {
		console.log(JSON.stringify(action))
	}
	trackEvent(action)
	const db = firebase.firestore()
	return db
		.collection("users")
		.doc(uid)
		.collection("requests")
		.add(
			Object.assign({}, action, {
				createdAt: firebase.firestore.FieldValue.serverTimestamp(),
			})
		)
		.then(
			ref =>
				new Promise((resolve, reject) => {
					window.setTimeout(
						() => reject(new Error(`Request took too long.`)),
						TIMEOUT
					)
					const unsubscribe = ref.onSnapshot(doc => {
						const { response } = doc.data()
						if (response !== undefined) {
							if (cb !== null) {
								cb(response)
							}
							if (response.errors !== undefined) {
								for (const id of Object.keys(response.errors)) {
									const message = response.errors[id]
									if (id === "server") {
										unsubscribe()
										ref.delete()
										reject(serverError(message))
										return
									}
								}
							}
							if (response.done) {
								unsubscribe()
								ref.delete()
								if (response.errors) {
									trackResponseErrors(response.errors)
								}
								resolve(response)
							}
						}
					}, reject)
				})
		)
}

function serverError(message) {
	const error = new Error(message)
	error.name = "ServerError"
	return error
}

function trackEvent(event) {
	const { action, payload } = event
	const label =
		action === "setAccount"
			? payload.type
			: action === "createInvoice"
				? `${payload.months} months`
				: isActionPayloadLabel(action) ? payload : null
	if (label !== null) {
		analytics.gaAll("send", "event", "Request", action, label)
	} else {
		analytics.gaAll("send", "event", "Request", action)
	}
}

function isActionPayloadLabel(action) {
	switch (action) {
		case "deleteAccount":
		case "dismiss":
			return true
		default:
			return false
	}
}

function trackResponseErrors(errors) {
	for (const id of Object.keys(errors)) {
		const error = new Error(errors[id])
		error.name = id
		analytics.trackError(error)
	}
}



// WEBPACK FOOTER //
// ./src/request.js